<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <!--コンテンツ-->
    <main id="renew3_mypage">
      <div class="mypage_back mypage_account">
        <div class="wrapper">
          <h2 class="m-h2">マイページ</h2>
          <p class="m-lead">マイページが新しくなりました。データバックアップ・復旧機能を利用したい場合は、<a href="/oldmypage" target="_blank"
              class="text-link">旧マイページ</a>にアクセスしてください。</p>

          <div class="my-contents sp">

            <mypagemenu-item viewFlag="my"></mypagemenu-item>

            <!--contents-->
            <div class="my-contents_container">
              <h2 class="m-h2">アカウント情報</h2>
              <p class="m-lead">こんにちは<span>{{ username }}</span>さん、<br>
                <span v-if="!$globalVar.isYagiPrime">一般会員</span><span v-else>ヤギプライム会員</span>としてログイン中です。
              </p>

              <ul class="list">
                <li class="item">
                  <div class="list_wrap">
                    <div class="item01">
                      <p class="item01-01">名前</p>
                      <p class="item01-02">{{ username }}</p>
                    </div>
                  </div>
                </li>
                <li class="item">
                  <div class="flex list_wrap">
                    <div class="item01">
                      <p class="item01-01">メールアドレス</p>
                      <p class="item01-02">{{ useremail }}</p>
                    </div>

                    <div class="item02">
                      <a href="/mypage/basicinfo" class="item02-01">メールアドレスの変更</a>
                    </div>
                  </div>
                </li>
                <li class="item" v-if="!$globalVar.isYagiPrime">
                  <div class="flex list_wrap">
                    <div class="item01">
                      <p class="item01-01">会員タイプ</p>
                      <p class="item01-02">一般会員</p>
                    </div>

                    <div class="item02">
                      <a href="/yagiprimeinfo" class="item02-01">ヤギプライム会員特典を見る</a>
                    </div>
                  </div>
                </li>
                <li class="item" v-else>
                  <div class="flex list_wrap">
                    <div class="item01">
                      <p class="item01-01">会員タイプ</p>
                      <p class="item01-02">ヤギプライム会員</p>
                    </div>

                    <div class="item02" v-if="!subscribedData.is_cancel">
                      <a href="/yagiprimecancel" class="item02-01">ヤギプライム会員解約</a>
                    </div>
                    <div class="item02" v-else>
                      解約済<br>
                      終了予定日時：{{ subscribedData.cancel_date }}
                    </div>
                  </div>
                </li>
                <li class="item" v-if="$globalVar.isYagiPrime">
                  <div class="flex list_wrap">
                    <div class="item01">
                      <p class="item01-01">決済方法</p>
                      <p class="item01-02">クレジットカード</p>
                      <p class="item01-03">次回決済日：{{ next_billing_date }}</p>
                    </div>
                  </div>
                </li>
                <li class="item">
                  <div class="flex list_wrap">
                    <div class="item01">
                      <p class="item01-01">その他の設定</p>
                    </div>

                    <div class="item02">
                      <a href="/mypage/accountother" class="item02-01">設定の変更</a>
                    </div>
                  </div>
                </li>
              </ul>

            </div>

            <mypagemenu-item viewFlag="service"></mypagemenu-item>

          </div>

          <div class="my-contents pc flex">
            <div class="menu-column">


              <mypagemenu-item viewFlag="my"></mypagemenu-item>


              <mypagemenu-item viewFlag="service"></mypagemenu-item>
            </div>

            <div class="right-contents">
              <!--contents-->
              <div class="my-contents_container">
                <h2 class="m-h2">アカウント情報</h2>
                <p class="m-lead">こんにちは<span>{{ username }}</span>さん、<br>
                  <span v-if="!$globalVar.isYagiPrime">一般会員</span><span v-else>ヤギプライム会員</span>としてログイン中です。
                </p>

                <ul class="list">
                  <li class="item">
                    <div class="list_wrap">
                      <div class="item01">
                        <p class="item01-01">名前</p>
                        <p class="item01-02">{{ username }}</p>
                      </div>
                    </div>
                  </li>
                  <li class="item">
                    <div class="flex list_wrap">
                      <div class="item01">
                        <p class="item01-01">メールアドレス</p>
                        <p class="item01-02">{{ useremail }}</p>
                      </div>

                      <div class="item02">
                        <a href="/mypage/basicinfo" class="item02-01">メールアドレスの変更</a>
                      </div>
                    </div>
                  </li>
                  <li class="item" v-if="!$globalVar.isYagiPrime">
                    <div class="flex list_wrap">
                      <div class="item01">
                        <p class="item01-01">会員タイプ</p>
                        <p class="item01-02">一般会員</p>
                      </div>

                      <div class="item02">
                        <a href="/yagiprimeinfo" class="item02-01">ヤギプライム会員特典を見る</a>
                      </div>
                    </div>
                  </li>
                  <li class="item" v-else>
                    <div class="flex list_wrap">
                      <div class="item01">
                        <p class="item01-01">会員タイプ</p>
                        <p class="item01-02">ヤギプライム会員</p>
                      </div>

                      <div class="item02" v-if="!subscribedData.is_cancel">
                        <a href="/yagiprimecancel" class="item02-01">ヤギプライム会員解約</a>
                      </div>
                      <div class="item02" v-else>
                        解約済<br>
                        終了予定日時：{{ subscribedData.cancel_date }}
                      </div>
                    </div>
                  </li>
                  <li class="item" v-if="$globalVar.isYagiPrime">
                    <div class="flex list_wrap">
                      <div class="item01">
                        <p class="item01-01">決済方法</p>
                        <p class="item01-02">クレジットカード</p>
                        <p class="item01-03">次回決済日：{{ next_billing_date }}</p>
                      </div>
                    </div>
                  </li>
                  <li class="item">
                    <div class="flex list_wrap">
                      <div class="item01">
                        <p class="item01-01">その他の設定</p>
                      </div>

                      <div class="item02">
                        <a href="/mypage/accountother" class="item02-01">設定の変更</a>
                      </div>
                    </div>
                  </li>
                </ul>

              </div>

            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<style lang="css" src="@/assets/css/renew3_mypage.css"></style>
<style scoped>
@import "/static/css/slick-theme.css";
@import "/static/css/slick.css";
/* @import url("//unpkg.com/element-ui@2.15.13/lib/theme-chalk/index.css"); */
</style>


<script>
import {
  TabPane,
  Tabs,
  MessageBox
} from 'element-ui'
import LoginForms from '@/components/RenewLoginForms'
import Slick from 'vue-slick'
import firebase from 'firebase/app'
import MypageCommonMenu from '@/components/formats/CommonParts/MypageCommonMenu'

const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const DOC_PAPER_HEIGHT_PX = 794
export default {
  components: {
    'el-tabs': Tabs,
    'el-tab-pane': TabPane,
    'login-forms': LoginForms,
    'mypagemenu-item': MypageCommonMenu,
    Slick
  },
  data: function () {
    return {
      fullscreenLoading: true,
      recentEdit: {
        FormatId: ''
      },
      introData: {},
      backupList: {
        auto: [],
        user: []
      },
      dialogVisible: false,
      username: '',
      useremail: '',
      subscribedData: {},
      selectedYagiOfferData: {},
      selectedQuickEmailData: {},
      mypagedata: [],
      quickemailList: [],
      qmail_rirekisho_html: '',
      qmail_shokumukeirekisho_html: '',
      joblistKeyword: '',
      joblistArea: '',
      backupListLoaded: {
        auto: false,
        user: false
      },
      slickOptions: {
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 2400,
        speed: 400
      },
      saved: false,
      recomm_code: '',
      saveLabel: '',
      backupDataToConfirm: null,
      previewScale: 1,
      previewQEmailScale: 1,
      backupDataViewerCssRirekisho: {},
      backupDataViewerCssShokurekisho: {},
      qmailViewerCssRirekisho: {},
      qmailViewerCssShokurekisho: {},
      deleteBackupPopoverVisible: false,
      previewLoading: false,
      rirekisho_height: 110,
      keirekisho_height: 110,
      previewQEmailLoading: false,
      job_list: [],
      activeTabName: 'user',
      activePreviewTab: 'format_rirekisho',
      activeQEmailPreviewTab: 'format_rirekisho',
      search_id: '',
      next_billing_date: ''
    }
  },
  computed: {
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    authStateChanged: async function () {
      const app = this

      this.$iterateStorage(function (value, key, iterationNumber) {
        if (key === 'basicData') {
          app.formatData = value
        }
      }, function (err) { })

      console.log('mypage logined')
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('version', '2')
      formData.append('reqflg', '2')
      formData.append('email', this.$firebase.user.email)
      formData.append('site_flag', 'r')
      formData.append('device_flag', app.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('email_verified', this.$firebase.user.emailVerified ? '1' : '0')

      app.$axios
        .post(app.$varuna.endPoints.getMypageHistory, formData, { timeout: 60000 })
        .then(function (response) {
          app.mypagedata = response.data
          if (app.$firebase.user.displayName) {
            app.username = app.$firebase.user.displayName
            app.useremail = app.$firebase.user.email
          } else if (app.mypagedata.memberdata.lastname) {
            app.username = app.mypagedata.memberdata.lastname + " " + app.mypagedata.memberdata.firstname
            app.useremail = app.$firebase.user.email
          } else {
            app.username = app.$firebase.user.email
          }
          console.error(app.mypagedata.memberdata.offers)
          app.joblistKeyword = app.mypagedata.memberdata.keyword
          app.joblistArea = app.mypagedata.memberdata.area
          app.job_list = app.mypagedata.memberdata.offers.offers
          app.search_id = app.mypagedata.memberdata.offers.search_id

        })
        .catch(function (error) {
          if (app.$firebase.user.displayName) {
            app.username = app.$firebase.user.displayName
            app.useremail = app.$firebase.user.email
          } else {
            app.username = app.$firebase.user.email
          }
        }).finally(function () {
          app.fullscreenLoading = false
        })

      this.$axios
        .get(this.$varuna.endPoints.isSubscribed + this.$firebase.user.uid + '/', null, { timeout: 60000 })
        .then(function (response) {
          console.error(response.data.is_subscribed)
          app.$globalVar.isYagiPrime = response.data.is_subscribed
          app.subscribedData = response.data
          if (response.data.is_subscribed) {

            app.$axios
              .get(app.$varuna.endPoints.subscriptions + app.$firebase.user.uid + '/', null, { timeout: 60000 })
              .then(function (response) {
                console.error(response.data)
                app.next_billing_date = response.data.next_billing_date

              })
              .catch(function (error) {

              }).finally(function () {
                app.fullscreenLoading = false
              })
          }

        })
        .catch(function (error) {

        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  created: function () {

    const app = this



  },
  beforeMount: function () {
    console.error("beforeMount:" + this.$route.query.custom_token)
    this.$eventHub.$on('firebase-initialized', this.authStateChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('firebase-initialized', this.authStateChanged)
  }
}
</script>
